import API_ENDPOINTS from '../config/api';
import { post, get } from '../utils/api';

/**
 * Payment Service - Razorpay Gateway integration
 */

// Dynamically load Razorpay SDK
export const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => {
      console.error('Failed to load Razorpay SDK');
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

// Create secure order on backend
export const createPaymentOrder = async (orderData) => {
  return await post(API_ENDPOINTS.createOrder, orderData);
};

// Verify payment cryptographic signature on backend
export const verifyPayment = async (verificationData) => {
  return await post(API_ENDPOINTS.verifyPayment, verificationData);
};

// Get enrollment receipt details
export const getEnrollmentById = async (id) => {
  return await get(API_ENDPOINTS.enrollmentById(id));
};

// Get current logged-in student enrollments
export const getMyEnrollments = async () => {
  return await get(API_ENDPOINTS.myEnrollments);
};

// Check if logged-in user is already enrolled in a course
export const checkCourseEnrollment = async (courseId) => {
  return await get(API_ENDPOINTS.checkEnrollment(courseId));
};

const paymentService = {
  loadRazorpayScript,
  createPaymentOrder,
  verifyPayment,
  getEnrollmentById,
  getMyEnrollments,
  checkCourseEnrollment
};

export default paymentService;
